import { Tag } from 'antd';
import type { TNullable } from 'utils/types/common';
import type { TComponent } from 'utils/types/component';

import styles from './amountCell.module.scss';

interface IAmountCellProps {
    amount: number;
    refundAmount: TNullable<number>;
}

const AmountCell: TComponent<IAmountCellProps> = (props) => {
    const { amount, refundAmount } = props;

    return (
        <div className={styles.amountCell}>
            <Tag className={styles.amountTag} color='green'>
                {amount}
            </Tag>
            {refundAmount && (
                <Tag className={styles.amountTag} color='red'>
                    {refundAmount}
                </Tag>
            )}
        </div>
    );
};

export { AmountCell };
